import React, { useRef, useEffect, useState } from 'react'

export function Video({
  video = '',
  className = '',
  children,
}) {

  const videoRef = useRef();
  let [showOverlay, setShowOverlay] = useState(true)

  useEffect(() => {
    ['pause', 'play'].forEach(e => videoRef.current.addEventListener(e,
      (e) => {
        setShowOverlay(videoRef.current.paused);
      }
    ))
  })

  function togglePlay(state = null) {
    if (videoRef.current.paused || state === true) {
      videoRef.current.play();
    } else if(!videoRef.current.paused || state === false) {
      videoRef.current.pause();
    }
  }

  return (
    <div className="relative">
      <div className="relative select-none" onClick={() => { togglePlay() }}>
        <div className={`absolute z-1 flex flex-col justify-center items-center flex-1 w-full h-full bg-gray-500/30 transition-opacity ${!showOverlay && 'opacity-0'}`}>
          <img className="w-1/4 h-1/4" src="/images/play.svg" alt="Play video" />
        </div>
        <video className={className} width="100%" preload="metadata" ref={videoRef}>
            <source src={`/videos/${video}.mp4`} type="video/mp4" />
            <source src={`/videos/${video}.webm`} type="video/webm" />
            Sorry, your browser doesn't support embedded videos.
        </video>
      </div>
      <div>
        {children}
      </div>
    </div>
  )
}
